export default function StatBox({ icon, label, value, dot }) {
  return (
    <div className="bg-white border border-slate-200 rounded-md p-4">
      <div className="flex items-center justify-between mb-2">
        <span className="text-slate-500">{icon}</span>
        {dot && <span className={`inline-block h-2 w-2 rounded-full ${dot}`} />}
      </div>
      <p className="font-display text-2xl font-bold tracking-tight">{value}</p>
      <p className="text-xs uppercase tracking-[0.15em] text-slate-500 font-semibold mt-1">
        {label}
      </p>
    </div>
  );
}